import { render, staticRenderFns } from "./feature-icon.vue?vue&type=template&id=e34b2e12&scoped=true&"
import script from "./feature-icon.vue?vue&type=script&lang=js&"
export * from "./feature-icon.vue?vue&type=script&lang=js&"
import style0 from "./feature-icon.vue?vue&type=style&index=0&id=e34b2e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34b2e12",
  null
  
)

export default component.exports